import ClearIcon from '@material-ui/icons/Clear'
import CheckIcon from '@material-ui/icons/Check'

const useStyles = makeStyles((theme) => ({
  box: (props) => ({
    borderWidth: 3,
    borderStyle: 'solid',
    borderColor: 'white',
    height: 100,
    width: 100,
    minWidth: 40,
  }),
  icon: (props) => ({
    color: 'white',
    width: '100%',
    height: '100%',
  }),
}))

const IconBox = (props) => {
  const classes = useStyles(props)

  return (
    <div className={classes.box}>
      {props.good ? (
        <CheckIcon className={classes.icon} />
      ) : (
        <ClearIcon className={classes.icon} />
      )}
    </div>
  )
}

export default IconBox
